import { TableFilterTabIconName } from '@kuiper/icons';
import { FilterOption } from '../../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { FilterMapping } from '../../../../../../ui-components/lib/filter-dropdown/filter-mapping.enum';
import { ENDPOINTS } from '../../../../../common/constants/endpoints.constants';
import { TableFilterTabKey } from '../../../../../common/enums/table-filter-tab-key';
import { ActionList } from '../../../../../common/models/action-list.model';

export { TableFilterTabKey as HISTORY_TAB_KEYS };

export const HISTORY_ARCHIVE_REQUEST_TYPE = 'flow_template';

export const HISTORY_COLUMNS_CONFIG: {
  header: string;
  identifier?: string;
  isSortable?: boolean;
  sortKey?: string;
}[] = [
  { header: '' },
  {
    header: 'history_tab_id_header_title',
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    header: 'history_tab_creator_header_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'history_tab_creation_date_header_title',
    isSortable: true,
    sortKey: 'creation_date][type',
  },
  {
    header: 'history_tab_completion_date_header_title',
    isSortable: true,
    sortKey: 'completion_date][type',
  },
  { header: 'remaining_time_header_title', isSortable: false },
  {
    header: 'history_tab_request_subject_header_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'history_tab_related_project_header_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'history_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  { header: 'history_tab_assignee_header_title' },
  {
    identifier: 'status',
    header: 'history_tab_status_header_title',
    isSortable: true,
    sortKey: 'state][type',
  },
  { header: '' },
];

export const HISTORY_ID_COLUMN_INDEX = 1;

export const HISTORY_TABLE_FILTER_TABS: {
  key: string;
  label: string;
  active: boolean;
  iconName: TableFilterTabIconName;
}[] = [
  {
    key: TableFilterTabKey.ALL,
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: TableFilterTabKey.IN_PROGRESS,
    label: 'table_filter_tab_inprogress_label',
    active: false,
    iconName: 'inprogress',
  },
  {
    key: TableFilterTabKey.COMPLETED,
    label: 'table_filter_tab_completed_label',
    active: false,
    iconName: 'completed',
  },
  {
    key: TableFilterTabKey.REJECTED,
    label: 'table_filter_tab_rejected_label',
    active: false,
    iconName: 'rejected',
  },
  {
    key: TableFilterTabKey.ON_HOLD,
    label: 'table_filter_tab_on_hold_label',
    active: false,
    iconName: 'hold',
  },
  {
    key: TableFilterTabKey.ARCHIVED,
    label: 'table_filter_tab_archived_label',
    active: false,
    iconName: 'archived',
  },
];

export const HISTORY_VIEW_DETAILS_ACTION: Omit<ActionList, 'label'> & {
  label: string;
} = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
  routerLinks: [],
};

export const HISTORY_ARCHIVE_ACTION: Omit<ActionList, 'label'> & {
  label: string;
} = {
  key: 'archive',
  hasIcon: true,
  label: 'archive_action_item_label',
  hasDivider: false,
  labelCustomStyle: 'text-destructive-500 text-xs',
  hasToggle: false,
  toggleValue: false,
};

export const HISTORY_RESTORE_ACTION: Omit<ActionList, 'label'> & {
  label: string;
} = {
  key: 'restore',
  hasIcon: true,
  label: 'restore_action_item_label',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
};

export const HISTORY_FILTER_MAPPING: Record<string, string> = {
  creationDateStart: FilterMapping.CREATED_AFTER_REQUESTS,
  creationDateEnd: FilterMapping.CREATED_BEFORE_REQUESTS,
  completionDateStart: FilterMapping.COMPLETED_AFTER_REQUESTS,
  completionDateEnd: FilterMapping.COMPLETED_BEFORE_REQUESTS,
  projectIds: FilterMapping.PROJECT_IDS,
};

export const filterOptions: FilterOption[] = [
  {
    key: 'creationDate',
    label: 'assigned_to_me_filter_creation_date_label',
    type: 'dateRange',
  },
  {
    key: 'completionDate',
    label: 'completion_date_filter_label',
    type: 'dateRange',
  },
  {
    key: 'projectIds',
    label: 'vendor_invoice_page_table_filter_option_product',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.project,
    placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
  },
  {
    key: 'resourceType',
    label: 'filter_resources_type_label',
    type: 'resourceType',
  },
];
